import { render, staticRenderFns } from "./AvailableSites.vue?vue&type=template&id=cbb0cd10&"
import script from "./AvailableSites.vue?vue&type=script&lang=ts&"
export * from "./AvailableSites.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports